import React, { useState } from 'react'
import { FaArrowLeft } from 'react-icons/fa6'
import { Link, useNavigate} from 'react-router-dom'
import Sidebar from './partial/Sidebar'
import Header from './partial/Header'
import { useAddPackageMutation } from '../../redux/API/PackageTypeApi'
import toast, { Toaster } from 'react-hot-toast'
import ChangePassword from './partial/ChangePassword'

const AddPackageType = () => {
const [newClass, setNewClass] = useState("")
const [newSidebarClass, setNewSidebarClass] = useState("")  
const [showPass, setShowPass] = useState(false)
const [name, setName] = useState('')
const [error, setError] = useState('')
const [postData] = useAddPackageMutation()
const navigate = useNavigate()
const handleSubmit = (e) => {
  e.preventDefault()
  if(name === ""){
    setError("Please Enter Package Type*")
    setTimeout(() => {
      setError("")
    }, 4000);
    return;
  }
  postData({name: name}).then((res) => {
    if(res?.data?.success){
      setName('')
      navigate('/admin/package_type')
    }
    else{
      toast.error("Something went wrong, Please try later")
    }
  })
  .catch((err) => {
    toast.error(err)
  })
}

const handleToggle = () => {
  if (newClass === "") {
    setNewClass("main-active");
    } else {
      setNewClass("");
      }
      if(newSidebarClass === ""){
        setNewSidebarClass("closed");
      }
      else{
        setNewSidebarClass("");
      }
}


  return (
    <>
    <Toaster position='top-right'/>
    <Sidebar
    newSidebarClass={newSidebarClass}
    />
    <div className={`main-context ${newClass}`}>
      <Header
      handleToggle={handleToggle}
      setShowPass={setShowPass}
      />
     <div className="admin-dashboard p-4">
     <div aria-label="breadcrumb">
 <ol className="breadcrumb">
   <li className="breadcrumb-item active" aria-current="page">Add Package Type</li>
 </ol>
</div>
<div className="d-flex justify-content-end pe-2 mb-3">
         <Link to="/admin/package_type" className="btn btn-primary rounded-2">
         Back <FaArrowLeft/>
         </Link>
         </div>
         <div className="container card p-4">
          <form className='row' onSubmit={handleSubmit}>
             <div className='col-lg-7'>
            <label htmlFor="name">Package Type</label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                placeholder="Enter Package Type"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
             {
              error && (
                <p className="text-danger wel mt-1">{error}</p>
              )
             }
             </div>
              <div className='col-lg-5 text-end pt-4'>
              <button className="btn btn-primary px-4 rounded-2" type="submit">Submit</button>
              </div>
            </form>
</div>
</div>
</div>
{
      showPass && (
        <ChangePassword
        setShowPass={setShowPass}
        />
      )
    }
   </>
  )
}

export default AddPackageType